import React from "react";
const Experience = () => {
  return (
    <div className="experience" id="experiencie">
      <div className="d-flex justify-content-center my-4">
        <h1 className="text-uppercase colorTexto">Mis Logros</h1>
        
      </div>
      <p className="text-center" style={{ marginBottom: "90px" }}>
          Mis logros en desarrollo y otras habilidades
        </p>
      <div className="container experience-wrapper">
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2015</h3>
            <p>
              Ganador de reconocimiento en participación de concurso de lógica de programación orientada a robots.
            </p>
          </div>
        </div>
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2017</h3>
            <p>
              Ganador de 1° lugar de concurso de oratoria de zona paracentral del país.
            </p>
          </div>
        </div>
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2018</h3>
            <p>
              Graduado con honores (Bachiller integral y 1° lugar de promoción) de técnico en Infraestructura Tecnológica y Servicios Informáticos.
            </p>
            <p>
              Acreedor de beca presidencial por parte del gobierno de El Salvador, bajo el subprograma de becas a la excelencia.
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2019</h3>
            <p>
            Impartición de tutorías (clases) de matemática a nivel de educación superior.
            </p>
            <p>
            Finalización de curso de CISCO, obtención de certificado en	IT Essentials: PC Hardware and Software así como merecedor de carta de mérito por alto rendimiento en dicho curso.
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2020</h3>
            <p>
            Finalización de curso de CISCO, obtención de certificado en CCNA Routing and Switching así como merecedor de carta de mérito por alto rendimiento en dicho curso.
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2020 Noviembre - 2021 Febrero</h3>
            <p>
              Desarrollo de prácticas profesionales en proyecto similar a Uber Eats o Hugo utilizando Ant Design, React JS y Cloud Firebase.
            </p>
            <p>
              Finalización de curso de Javascript y obtención de <b>diploma por parte de secretaría de la innovación de la presidencia de El Salvador como Full Stack developer con JavaScript.</b>
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2021 Febrero - 2021 Febrero</h3>
            <p>
              Freelance en proyecto de donaciones realizado con Angular JS, API REST, entre otras tecnologías (Con hosting en Firebase)
            </p>
            <p>
              Ascensión de nivel de inglés intermedio B1 en academía de idiomas.
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2021 Marzo - 2021 Marzo</h3>
            <p>
              Freelance de proyecto para administración de alcaldías orientada a dispositivos móviles realizado con React Native
            </p>
            <p>
              Desarrollo de proyecto para administración de hoteles realizado con React, Redux y Material UI (Con hosting en netlify). 
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2021 Abril - 2021 Abril</h3>
            <p>
              Desarrollo de proyecto sistema de inventario y venta de productos realizado con React Redux, MongoDB, Node JS, Express JS (Stack MERN) y Ant Design (Con hosting de backend en Heroku y frontend en Netlify).
            </p>
            
            <p>
              Freelance de proyecto para inscripción mensual de promociones orientada a tienda de tatuajes realizada con React, TypeScript,YUP, Material UI, NodeJS, Express JS, Cloud Firebase y Nodemailer (Con hosting en netlify). 
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2021 Mayo - 2022 Junio</h3>
            <h4 style={{color:'black'}}> <b>Asesuisa Sura</b></h4>
            <h5 style={{color:'black'}}> <b>Full stack developer</b></h5>
            <p>
            Contratado por la empresa Syntepro que presta servicio de outsourcing en la empresa Asesuisa Sura
            </p>
            <p>
            Entrevistador, creador de pruebas técnicas y evaluador de resultados para contrataciones de plazas MERN.
            </p>
            <p>
            Generación de componentes en react, typescript, storybook, uso de redux, mongodb(NoSQL Booster for mongooDB), sql (Dbeaver), SourceTree, gitlab, C# .Net, Postman.
            </p>
            <p>
            Mantenimiento de api´s, aplicaciones de consola, proyectos con ASP, .NET y procedimientos almacenados (SQL). 
            </p>
          </div>
        </div>
        {/* - */}
        <div className="timeline-block timeline-block-right">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2022 Junio - 2022 Octubre</h3>
            <h4 style={{color:'black'}}> <b>Focus ITO Services </b></h4>
            <h5 style={{color:'black'}}> <b>Full stack developer</b></h5>
            <p>
            Contratado por la empresa Focus ITO Services generando soluciones de software para Clientes de Estado Unidos.
            </p>
            <p> 
            Creación y mantenimiento de API para aplicacion movil con tecnologías orientadas a real time (socket.io) manejo de algoritmos para búsqueda de usuarios en mapa haciendo uso de cálculos por medio de geolocalizaciones, uso de Docker, Redis, PostgreSQL, Prisma, Node js, Express js, CronJobs, Socket Io, Gitlab entre otras tecnologías
            </p>
          </div>
        </div>
        {/*  */}
        <div className="timeline-block timeline-block-left">
          <div className="marker"></div>
          <div className="timeline-content">
            <h3>2022 Octubre - Actualmente</h3>
            <h4 style={{color:'black'}}> <b>Service Intel - eAutoClub</b></h4>
            <h5 style={{color:'black'}}> <b>Full Stack System Software Engineer</b></h5>
            <p>
            Contratado por empresa estadounidense eAutoClub, Inc. – Service Intel Ligence Social desarrollando soluciones de software
            </p>
            <p>
            Generación de componentes en react, typescript, storybook, uso de redux.
            </p>
            <p>
            Creación y mantenimiento de microservicios con Node js y express, API orientadas a proporcionar herramientas para facilitar el uso del sistema, como lo son real time (socket.io) para manejo de chat. Creación de documentación de endpoints en postman.
            </p>
            <p>
            Realización de migraciones y optimización de base de datos, manejo de optimización en mongodb(NoSQL Booster for mongooDB) 
            </p>
            <p>
            Uso de Docker, Node js, Express js, Socket Io, Graphql, Apollo Server, Bitbucket, PWA entre otras tecnologías
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Experience;